import { jsx as n, Fragment as r } from "react/jsx-runtime";
import { CustomLink as f } from "./style.js";
function e({
  title: i,
  url: o,
  children: t,
  ...m
}) {
  return o ? /* @__PURE__ */ n(f, { title: i, url: o, ...m, children: t }) : (
    // eslint-disable-next-line react/jsx-no-useless-fragment
    /* @__PURE__ */ n(r, { children: t })
  );
}
export {
  e as ConditionalLink
};
